import React, { useEffect } from 'react'
import WalletHistoryTable from '../../../components/transactionNew/wallet/WalletHistoryTable'
import useTransactions from '../../../core/hooks/useTransaction'
import { useWindowSize } from '../../../modules/staking'
import { MOBILE_SIZE } from '../../../core/constants/common'
import RWalletHistoryTable from '../../../components/transactionNew/wallet/RWalletHistoryTable'

const WalletTransactionsHistory = ({ type = 'bank', flow = '' }) => {
    const { width } = useWindowSize()

    return (
        <>
            {width >= MOBILE_SIZE ? <WalletHistoryTable /> : <RWalletHistoryTable />}
        </>
    )
}

export default WalletTransactionsHistory